var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.923 12.389L28.8328 0.298925C28.6413 0.107519 28.3818 0 28.1112 0H4.95917C2.2246 0 0 2.2248 0 4.95937V45.0407C0 47.7752 2.2247 50 4.95927 50H36.2626C38.9972 50 41.2219 47.7753 41.2219 45.0407V13.1106C41.2218 12.84 41.1143 12.5804 40.923 12.389ZM29.1319 3.48427L37.738 12.0903H32.0503C31.2706 12.0903 30.5376 11.7867 29.9865 11.2355C29.4352 10.6845 29.1318 9.95154 29.1319 9.17196V3.48427ZM39.181 45.0406C39.181 46.6499 37.8718 47.9591 36.2626 47.9591H4.95917C3.3499 47.9591 2.04072 46.6499 2.04072 45.0406V4.95937C2.04082 3.35009 3.34999 2.04082 4.95917 2.04082H27.0911V9.17176C27.0909 10.4965 27.6067 11.7419 28.5433 12.6785C29.48 13.6152 30.7254 14.131 32.0502 14.131H39.1809L39.181 45.0406Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0436 29.6626H9.58681C9.02334 29.6626 8.56641 30.1194 8.56641 30.683C8.56641 31.2466 9.02334 31.7034 9.58681 31.7034H10.0436C10.6071 31.7034 11.0641 31.2466 11.0641 30.683C11.0641 30.1194 10.6071 29.6626 10.0436 29.6626Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6352 29.6626H13.3446C12.7812 29.6626 12.3242 30.1194 12.3242 30.683C12.3242 31.2466 12.7812 31.7034 13.3446 31.7034H31.6352C32.1987 31.7034 32.6556 31.2466 32.6556 30.683C32.6556 30.1194 32.1987 29.6626 31.6352 29.6626Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0436 25H9.58681C9.02334 25 8.56641 25.4568 8.56641 26.0204C8.56641 26.584 9.02334 27.0408 9.58681 27.0408H10.0436C10.6071 27.0408 11.0641 26.584 11.0641 26.0204C11.0641 25.4568 10.6071 25 10.0436 25Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6352 25H13.3446C12.7812 25 12.3242 25.4568 12.3242 26.0204C12.3242 26.584 12.7812 27.0408 13.3446 27.0408H31.6352C32.1987 27.0408 32.6556 26.584 32.6556 26.0204C32.6556 25.4568 32.1987 25 31.6352 25Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0436 20.3374H9.58681C9.02334 20.3374 8.56641 20.7942 8.56641 21.3578C8.56641 21.9214 9.02334 22.3782 9.58681 22.3782H10.0436C10.6071 22.3782 11.0641 21.9214 11.0641 21.3578C11.0641 20.7942 10.6071 20.3374 10.0436 20.3374Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6352 20.3374H13.3446C12.7812 20.3374 12.3242 20.7942 12.3242 21.3578C12.3242 21.9214 12.7812 22.3782 13.3446 22.3782H31.6352C32.1987 22.3782 32.6556 21.9214 32.6556 21.3578C32.6556 20.7942 32.1987 20.3374 31.6352 20.3374Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcon);
export default __webpack_public_path__ + "static/media/terms_icon.109ae4ce91737c9073307fad3dd8e452.svg";
export { ForwardRef as ReactComponent };